/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react'
import SidePopup from '../../../../components/SidePopup';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import Loader from '../../../../components/Loader';
import GlobalContext from '../../../../components/Context/GloablContext';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import S3UploadHook from '../../../../CommonMethods/S3UploadHook';
import Toast from '../../../../components/Toast';
import { dataService } from '../../../../services/data.services';
import { ShimmerTitle } from 'react-shimmer-effects';
import FailedPopup from './FailedPopup';

export default function SidePopupBar({
    handleSidePopupClick,
    getStudentsDirectory,
    academicYears = [],
    classes = [],
    selectedAcademicYear = "",
    selectedClass = "",
    selectedSection = "",
    onAcademicYearChange = null,
    onClassChange = null,
    onSectionChange = null,
    handleSampleFileDownload,
    isBulkInvite = false,
}) {
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const {setToastmessage} = useContext(GlobalContext);
    const [actionErrorMessage, setActionErrorMessage] = useState("");
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const dropdownRef = useRef()
    const fileInputRef = useRef(null)
    const [buttonLoading,setButtonLoading] = useState(false)
    const [progressCount, setprogressCount] = useState(0)
    const [failureData, setFailureData] = useState({})
    const [openStatus, setOpenStatus] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    const [studentS3Key, setStudentS3Key] = useState("")
    const [studentFileError, setStudentFileError] = useState(false)
    const [academicYearDropdownOpen, setAcademicYearDropdownOpen] = useState(false)
    const [classDropdownOpen, setClassDropdownOpen] = useState(false)
    const [sectionDropdownOpen, setSectionDropdownOpen] = useState(false)
    const [sections, setSections] = useState([])
    const [sectionLoading, setSectionLoading] = useState(false)
    const currentButtonLoading = buttonLoading;
    const [ignoreExistingLogin, setIgnoreExistingLogin] = useState(true);


    const handleAcademicYearDropdownToggle = () => {
        setClassDropdownOpen(false);
        setSectionDropdownOpen(false);
        setAcademicYearDropdownOpen(!academicYearDropdownOpen);
    }

    const handleClassDropdownToggle = () => {
        setAcademicYearDropdownOpen(false);
        setSectionDropdownOpen(false);
        setClassDropdownOpen(!classDropdownOpen);
    }

    const handleSectionDropdownToggle = () => {
        setClassDropdownOpen(false);
        setAcademicYearDropdownOpen(false);
        setSectionDropdownOpen(!sectionDropdownOpen);
    }

    useOnClickOutside(dropdownRef,()=>{
        setDropDownOpen(false)
    })

    const handleStudentImportFile = async (e) => {
        if(e.target.files !== undefined) {
            setStudentFileError(false)
            let file = e.target.files[0];
            let url = ''
            if (file && file.name && file.type) {
                const branch_id = await GetBranchId()
                url = await S3UploadHook(file, `students/${branch_id}/${file.name}`, setprogressCount, true);
                setStudentS3Key(url)
            }
            e.target.value = null;
        }
    }

    async function handleStudentSave() {
        if (!selectedAcademicYear) {
            setToastErrorMessage("Please select an Academic Year");
            return;
        }
        if (!isBulkInvite && !selectedClass) {
            setToastErrorMessage("Please select a Class");
            return;
        }
        if (!isBulkInvite && !selectedSection) {
            setToastErrorMessage("Please select a Section");
            return;
        }

        // File required only for upload (not bulk invite)
        if (!isBulkInvite && !studentS3Key) {
            setStudentFileError(true);
            setToastErrorMessage("Please upload the student file");
            return;
        }

        setButtonLoading(true);
        setIsDisabled(true);

        try {
            const branch_id = await GetBranchId();

            // 🔹 COMMON PAYLOAD
            let body = {
                branch_id,
                academic_year: {
                    name: selectedAcademicYear?.name,
                    start_date: selectedAcademicYear?.start_date,
                    end_date: selectedAcademicYear?.end_date,
                    academic_year_id: selectedAcademicYear?._id,
                },
                class: {
                    class_id: selectedClass?._id,
                    class_name: selectedClass?.name,
                },
                section: {
                    section_id: selectedSection?.section_id,
                    section_name: selectedSection?.section_name,
                },
            };

            let response;

            // 🟦 BULK INVITE FLOW
            if (isBulkInvite) {
                body.is_bulk = true;
                body.ignore_existing_login = ignoreExistingLogin;
                const data = body
                const payload = { data };

                response = await dataService.PostAPI(payload, `students/send-invite`);

                setToastmessage(
                    response?.data?.message || "Parent invitation(s) sent successfully"
                );
                handleSidePopupClick();
                return;
            }

            // 🟩 UPLOAD STUDENTS FLOW
            const mandatorySubjects = selectedSection.subjects
                ? selectedSection.subjects.filter(
                    (subject) =>
                        !subject.subject_name.toLowerCase().includes("(optional)")
                )
                : [];

            body = {
                ...body,
                s3_key: studentS3Key,
                mandatory_subjects: mandatorySubjects,
            };

            const importresponse = await dataService.PostAPI(body, `students/upload`);
            const uploadResponseData = importresponse?.data?.data;

            if (uploadResponseData?.failed_records?.length === 0) {
                const uploadedCount = uploadResponseData?.uploaded_count;
                setOpenStatus(false);
                setToastmessage(
                    uploadedCount !== undefined
                        ? `${uploadedCount} Student(s) uploaded successfully`
                        : uploadResponseData?.message
                );
                handleSidePopupClick();
                await getStudentsDirectory?.();
                return;
            }

            setFailureData(uploadResponseData || {});
        } catch (error) {
            setOpenStatus(false);
            setToastErrorMessage(
                error?.response?.data?.message || "Something went wrong"
            );
            setFailureData(error?.response?.data || {});
        } finally {
            setButtonLoading(false);
            setIsDisabled(false);
        }
    }


    const callSectionAPI = async () => {
        setSectionLoading(true);
        if(selectedAcademicYear?.name!==undefined && selectedClass?.name!==undefined) {
            const branch_id = await GetBranchId();
            let endpoint = `associations?branch_id=${branch_id}&academic_year_id=${selectedAcademicYear?._id}&class_id=${selectedClass?._id}&filter=true&role=directory`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            setSections(temp);
        }
        setSectionLoading(false);
    }

    useEffect(() => {
        if (selectedAcademicYear?.name != "" && selectedClass?.name != "") {
            callSectionAPI()
            setSectionDropdownOpen()
        }
    }, [selectedAcademicYear?.name,selectedClass?.name]);

    return (
        <>
            <SidePopup
                addOpen={true}
                class="bg-''"
                componentName={isBulkInvite ? "Send Parent Invitations" : "Upload Students"}
                handleSidePopupClick={handleSidePopupClick}
                actionErrorMessage={actionErrorMessage}
                setActionErrorMessage={setActionErrorMessage}
                popUp={openStatus}
                element={
                    <>
                        {(failureData?.failed_records?.length === 0  || failureData?.failed_records === undefined) ? 
                            <>
                                <div className='px-6 pt-[22px]'>
                                    <div className='flex items-center mb-4'>
                                        <p className='text-f7 font-normal min-w-[120px]'>Academic Year<span className="req-fld-astrk">*</span></p>
                                        <div className='relative ml-3 w-[250px]' ref={dropdownRef}>
                                            <button 
                                                id='academic-year-dropdown'
                                                className='slct-inpt-fld'
                                                onClick={() => handleAcademicYearDropdownToggle()}
                                                disabled={isDisabled}>
                                                
                                                <p 
                                                    className={`text-start text-f7 font-normal ${selectedAcademicYear === "" ? "text-[#818E98]" : "text-[#031624]"} more-lines`}
                                                    title={selectedAcademicYear}
                                                >{selectedAcademicYear === "" ? "Select Academic Year" : selectedAcademicYear?.name}</p>
                                                <img loading="lazy" src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-4 ${academicYearDropdownOpen ? "transform rotate-180" : ""}`}/>
                                            </button>
                                            {academicYearDropdownOpen &&
                                                <ul className='slct_drp_dwn min-w-full max-h-[145px] overflow-auto z-10 scroll-bar'>
                                                    {
                                                        academicYears.length > 0 ? (
                                                            academicYears.map((item) => (
                                                                <p key={item._id}
                                                                    onClick={() => {
                                                                        onAcademicYearChange && onAcademicYearChange(item);
                                                                        handleAcademicYearDropdownToggle();
                                                                    }}
                                                                    className='slct_drp_dwn_optn'>{item.name} </p>))
                                                        ) : (
                                                            <p className='slct_drp_dwn_optn'>No Academic Years Available</p>
                                                        )}
                                                </ul>
                                            }
                                        </div>
                                    </div>
                                    <div className='flex items-center mb-4'>
                                        <p className='text-f7 font-normal min-w-[120px]'>Class{!isBulkInvite && <span className="req-fld-astrk">*</span>}</p>
                                        <div className='relative ml-3 w-[250px]' ref={dropdownRef}>
                                            <button 
                                                id='class-dropdown'
                                                className='slct-inpt-fld'
                                                onClick={() => handleClassDropdownToggle()}
                                                disabled={isDisabled}>
                                                <p 
                                                    className={`text-start text-f7 font-normal ${selectedClass === "" ? "text-[#818E98]" : "text-[#031624]"} more-lines`}
                                                    title={selectedClass}
                                                >{selectedClass === "" ? "Select Class" : selectedClass.name}</p>
                                                <img loading="lazy" src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-4 ${classDropdownOpen ? "transform rotate-180" : ""}`}/>
                                            </button>
                                            {classDropdownOpen &&
                                                <ul className='slct_drp_dwn min-w-full max-h-[145px] overflow-auto z-10 scroll-bar'>
                                                    {
                                                        classes.length > 0 ? (
                                                            classes.map((item) => (
                                                                <p key={item._id}
                                                                    onClick={() => {
                                                                        onClassChange && onClassChange(item);
                                                                        handleClassDropdownToggle();
                                                                    }}
                                                                    className='slct_drp_dwn_optn'>{item.name} </p>))
                                                        ) : (
                                                            <p className='slct_drp_dwn_optn'>No Classes Available</p>
                                                        )}
                                                </ul>
                                            }
                                        </div>
                                    </div>
                                    <div className='flex items-center mb-4'>
                                        <p className='text-f7 font-normal min-w-[120px]'>Section{!isBulkInvite && <span className="req-fld-astrk">*</span>}</p>
                                        <div className='relative ml-3 w-[250px]' ref={dropdownRef}>
                                            <button
                                                id='section-dropdown'
                                                className='slct-inpt-fld'
                                                onClick={handleSectionDropdownToggle}
                                                disabled={isDisabled}
                                            >
                                                <p
                                                    className={`text-start text-f7 font-normal ${selectedSection === "" ? "text-[#818E98]" : "text-[#031624]"} more-lines`}
                                                    title={selectedSection?.section_name || ""}
                                                >
                                                    {selectedSection === "" ? "Select Section" : selectedSection.section_name}
                                                </p>
                                                <img
                                                    loading="lazy"
                                                    src="/images/dropdown-icon.png"
                                                    alt="icon"
                                                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-4 ${sectionDropdownOpen ? "transform rotate-180" : ""}`}
                                                />
                                            </button>
                                            {sectionDropdownOpen && (
                                                <ul className='slct_drp_dwn min-w-full max-h-[145px] overflow-auto z-10 scroll-bar'>
                                                    {
                                                        sectionLoading
                                                            ?
                                                            (
                                                                <li className="max-h-[150px] overflow-auto scroll-bar px-2 py-1">
                                                                    <p className="text-2xl font-bold text-[#031624] mb-4 mt-4">
                                                                        <ShimmerTitle line={1} gap={6} variant="secondary" />
                                                                    </p>
                                                                </li>
                                                            )
                                                            :
                                                            (
                                                                sections.length > 0 ? (
                                                                    sections?.map((item) => (
                                                                        <li
                                                                            key={item.section_id}
                                                                            onClick={() => {
                                                                                onSectionChange && onSectionChange(item);
                                                                                handleSectionDropdownToggle();
                                                                            }}
                                                                            className='slct_drp_dwn_optn cursor-pointer'
                                                                        >
                                                                            {item.section_name}
                                                                        </li>
                                                                    ))) : (<p className='slct_drp_dwn_optn'>No Sections Available</p>)
                                                            )
                                                    }
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    {isBulkInvite && (
                                        <div className= "flex items-center mt-4">
                                            <div className="relative checkbox custom-checkBoxBlue1 mb-3 more-lines flex">
                                                <input
                                                    type="checkbox"
                                                    id="ignore_existing_login"
                                                    autocompleted="ignore_existing_login"
                                                    checked={ignoreExistingLogin}
                                                    onChange={(e) => setIgnoreExistingLogin(e.target.checked)}
                                                />
                                                <label
                                                    htmlFor="ignore_existing_login"
                                                    title="Ignore students who already have login access"
                                                >
                                                    Ignore students with existing login
                                                </label>
                                            </div>
                                        </div>
                                    )}


                                    {!isBulkInvite && (
                                        <div className='pb-5 border-b border-[#E6E8EA] mt-8'>
                                            <div className='flex justify-between'>
                                                <p className='text-[#031624] font-normal text-f7'>
                                                    &nbsp;
                                                </p>
                                                <p 
                                                    onClick={() => {handleSampleFileDownload && handleSampleFileDownload()}}
                                                    className='text-[#106EB4] font-normal text-f7 cursor-pointer'
                                                >
                                                    Download Sample File
                                                </p>
                                            </div>

                                            <div className={`relative border ${studentFileError && studentS3Key === "" ? "border-[#F04438]" : "border-[#4D555B]"} border-dashed py-5`}>
                                                <div
                                                    className='w-fit mx-auto mb-2 cursor-pointer'
                                                    id="file-upload-section"
                                                    onClick={() => {
                                                        if (!studentS3Key && fileInputRef.current) fileInputRef.current.click();
                                                    }}
                                                >
                                                    <img
                                                        src='/images/file-blue.svg'
                                                        className='w-[18px] mx-auto cursor-pointer'
                                                        alt="upload"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (!studentS3Key && fileInputRef.current) fileInputRef.current.click();
                                                        }}
                                                    />
                                                    <div className='relative mx-auto w-fit flex cursor-pointer' onClick={(e) => e.stopPropagation()}>
                                                        <label htmlFor="student_upload_file" className='text-f7 font-normal text-[#031624] flex items-center'>
                                                            <p className='more-lines break-all cursor-pointer' > 
                                                                {studentS3Key === "" ? "Click to select File" : studentS3Key.split("/")[studentS3Key.split("/")?.length - 1]}
                                                            </p>
                                                        </label>

                                                        <input
                                                            ref={fileInputRef}
                                                            title={studentS3Key.split("/")[studentS3Key.split("/")?.length - 1] || ""}
                                                            type={studentS3Key === "" ? "file" : "text"}
                                                            id="student_upload_file"
                                                            onChange={(e) => handleStudentImportFile(e)}
                                                            accept=".xlsx, .xls"
                                                            disabled={studentS3Key !== ""}
                                                            data-allowed-file-extensions=".xlsx,.xls"
                                                            className='opacity-0 absolute top-0 left-0 w-[50px] cursor-pointer'
                                                        />
                                                        <div>
                                                            {studentS3Key !== "" && <span>
                                                                <img
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    src="/images/file-remove.svg"
                                                                    alt="icon"
                                                                    className="w-5 h-5 ml-1 cursor-pointer mt-0.5"
                                                                    onClick={(e) => { e.stopPropagation(); setStudentS3Key("") }}
                                                                />
                                                            </span>}
                                                        </div>
                                                    </div>
                                                    <p className='text-[#344054] text-xs font-normal text-center'>Supported file type: xlsx</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className=" flex -mx-2.5 mt-5">
                                        <div className="w-1/2">
                                            <div className="w-full flex justify-end">
                                                <button 
                                                    onClick={() => {handleSidePopupClick(); getStudentsDirectory && getStudentsDirectory()}}
                                                    type="button" 
                                                    id='Cancel'
                                                    disabled={isDisabled}
                                                    className="cancl-btn" data-te-modal-dismiss="" aria-label="Close">Cancel</button>
                                            </div>
                                        </div>
                                        <div className="w-1/2">
                                            <div className="w-full">
                                                <button 
                                                    type="button" 
                                                    id="upload" 
                                                    onClick={() => handleStudentSave()}
                                                    disabled={false}
                                                    className="actn-btn onboardInstitution" 
                                                    tabIndex="0"
                                                >{currentButtonLoading ? <Loader /> : isBulkInvite ? ("Send") : ("Upload")}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {toastErrorMessage!=='' &&<Toast
                                    message={toastErrorMessage}
                                    type="error"
                                    setToastmessage={setToastErrorMessage} />}
                            </>
                            :
                            <div>
                                <FailedPopup
                                    handleSidePopupClick={handleSidePopupClick}
                                    setFailureData={setFailureData}
                                    failureData={failureData}
                                    getPayrollUsers={getStudentsDirectory}
                                />
                            </div>
                        }
                    </>
                }
            />
        </>
    )
}
